import { render, staticRenderFns } from "./CostomImg.vue?vue&type=template&id=46fe3fe4&scoped=true&"
import script from "./CostomImg.vue?vue&type=script&lang=js&"
export * from "./CostomImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fe3fe4",
  null
  
)

export default component.exports